'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// needs to be here in order to overwrite redux-segment location change actions for page view posts.

exports.default = {
    mapper: {
        '@@router/LOCATION_CHANGE': function routerLOCATION_CHANGE() {
            return {};
        }
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/analyticsActionMapper.js
// module id = 4hkW
// module chunks = 46